import type { FortuneIconProps } from '@/app_components/icons/constants';

export const FortuneLogoSecondary = ({ className, ...props }: FortuneIconProps) => (
  <svg
    className={className}
    fill='none'
    viewBox='0 0 56 56'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <title>Fortune Secondary Logo</title>
    <g clipPath='url(#clip0_3256_590)'>
      <path
        d='M56 0H0V56H56V0Z'
        fill='black'
      />
      <path
        d='M26.6451 9.68359H20.4375V15.8912H26.6451V9.68359Z'
        fill='#FFBD21'
      />
      <path
        d='M26.6445 9.68359L35.5625 15.8912V9.68359H26.6445Z'
        fill='white'
      />
      <path
        d='M26.6445 9.68359V15.8912H35.5625L26.6445 9.68359Z'
        fill='#00AEEF'
      />
      <path
        d='M32.3991 30.6141L26.6451 24.4065V15.8945H20.4375V46.3165L26.6451 30.6141H32.3991Z'
        fill='white'
      />
      <path
        d='M26.6445 24.4062L32.3985 30.6139V24.4062H26.6445Z'
        fill='#ED1C24'
      />
      <path
        d='M20.3671 46.2877L26.5745 46.3426L26.7132 30.6408L20.3671 46.2877Z'
        fill='#2ED83D'
      />
    </g>
    <defs>
      <clipPath id='clip0_3256_590'>
        <rect
          fill='white'
          height='56'
          width='56'
        />
      </clipPath>
    </defs>
  </svg>
);
